import { ReduxStore } from 'store/types';

function getAllThreadsEmptyMessage(state: ReduxStore): string {
  return state.intervention.getAllThreads.config.emptyMessage;
}

export default getAllThreadsEmptyMessage;
